import { CSSProperties, FC } from "react";
import { useViewerStore } from "../state";

// Matches the prod viewer's readout: a dark translucent pill, centered along
// the bottom edge (feedback #2). Sits above the attribution (which is now a
// small bottom-right pill), so they don't collide.
const BAR: CSSProperties = {
    position: "absolute",
    bottom: 0,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 4,
    padding: "4px 14px",
    background: "rgba(35, 55, 75, 0.9)",
    color: "#fff",
    borderRadius: "10px 10px 0 0",
    font: '13px/1.4 "Amazon Ember", "Helvetica Neue", Roboto, Arial, sans-serif',
    wordSpacing: "3px",
    pointerEvents: "none",
    whiteSpace: "nowrap",
};

/**
 * Bottom-right readout of the live camera (lng/lat/zoom/pitch/bearing), ported
 * from the 1.0 viewer's MapLocationBar. Reads the v2 store camera, which the
 * engine updates on every moveend. Overlay — costs no layout height.
 */
const MapLocationBar: FC = () => {
    const c = useViewerStore((s) => s.camera);
    return (
        <div style={BAR}>
            Lng: {c.lng.toFixed(4)} | Lat: {c.lat.toFixed(4)} | Zoom: {c.zoom.toFixed(2)} | Pitch:{" "}
            {c.pitch.toFixed(2)} | Bearing: {c.bearing.toFixed(2)}
        </div>
    );
};

export default MapLocationBar;
